<template>
  <div class="menucontrol-scroll fixed-top">
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto px-12 pt-12 pb-20"
      v-if="flowIndex == 0"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <projectname @projectStatus="projectStatus" />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center overflow-y-auto px-12 py-6"
      v-if="flowIndex == 1"
    >
      <div class="shadow bg-white rounded20 w-full mx-auto py-16">
        <div>
          <Plans @next="checkPlan" />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto px-12 pt-12 pb-20"
      v-if="flowIndex == 2"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <Platform />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto pt-12 pb-20"
      v-if="flowIndex == 3"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <Suites />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto px-12 pt-12 pb-20"
      v-if="flowIndex == 4"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <standardFeature />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto pt-12 pb-20"
      v-if="flowIndex == 5"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <customFunction />
        </div>
      </div>
    </div>
    <div
      class="flex justify-center w-full items-center logsdefine1 overflow-y-auto px-12 py-6"
      v-if="flowIndex == 6"
    >
      <div class="shadow bg-white rounded20 w-9/12 mx-auto py-16">
        <div>
          <customFunction2 />
        </div>
      </div>
    </div>

    <div
      class="px-16 py-4 mt-4 z-50 lg:w-10/12 md:w-3/4 w-full fixed right-0 bottom-0"
    >
      <div class="flex justify-between w-full">
        <vs-button
          @click="previousPage"
          color="secondary"
          type="filled"
          v-if="flowIndex >= 1"
          class="lg:px-16 md:px-16 py-4 px-12 lg:py-5 md:py-5 font-semibold sm-fsize14 fsize16 rounded-lg"
        >
          BACK
        </vs-button>
        <vs-button
          v-if="flowIndex != 1"
          @click="nextPage"
          type="filled"
          color="primary"
          class="lg:px-16 md:px-16 px-12 lg:py-5 md:py-5 font-semibold sm-fsize14 py-4 fsize16 rounded-lg"
        >
          NEXT
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import projectname from "./component/projectPage.vue";
import Platform from "./component/platformPage.vue";
import Plans from "./component/Plans.vue";
import Suites from "./component/suites.vue";
import standardFeature from "./component/standardFeature.vue";
import customFunction from "./component/customFunction.vue";
import customFunction2 from "./component/customFunction2.vue";

import jwt from "jsonwebtoken";
import axios from "axios";

export default {
  data() {
    return {
      flowIndex: 0,
      appStatus: false,
      claim: "",
      url: process.env.VUE_APP_BRAINED_API_URL,
    };
  },
  components: {
    projectname,
    customFunction,
    Platform,
    standardFeature,
    Plans,
    Suites,
    customFunction2,
  },
  methods: {
    authCheck() {
      const token1 = localStorage.getItem("token");
      if (token1) {
        this.claim = jwt.verify(
          token1,
          "TWFnaXR0IENvbnN1bHRhbmN5IHNlcnZlcyBidXNpbmVzc2VzIGluIGFsbCBtYWpvciBzZWN0b3JzLHByb3ZpZGluZyBleGNlcHRpb25hbCBzb2Z0d2FyZSBzb2x1dGlvbnMgZm9yIGxhcmdlIGNvcnBvcmF0aW9ucyxtaWQtc2l6ZWQgZW50ZXJwcmlzZXMsYW5kIHN0YXJ0dXAuundefined"
        );
      }
    },
    // means client has come till scope requirement
    async urlFlag() {
      const checkToken = localStorage.getItem("token");
      if (!checkToken) return;
      if (checkToken) {
        this.authCheck();
      }
      if (this.claim && !this.claim.userMobile) return;
      let flag = {
        mobile: this.claim.userMobile,
        flag: "scope-Requirments",
      };
      await axios.post(`${this.url}brained/user/userFlag`, flag);

      this.$store.commit("scope/SET_FLAG", flag.flag);
    },
    async updateLeadWithProjectName() {
      console.log("send poject name to db for lead");
      let details = [
        {
          App_Name: this.projectName,
        },
        {
          mobile: this.userDetails.mobile,
        },
      ];
      // await axios.post(`${this.url}brained/crm/update_lead`, details);
    },
    projectStatus(status) {
      this.appStatus = status;
    },
    backShow() {
      if (this.flowIndex >= 1 && this.flowIndex < 8) {
        return false;
      } else {
        return true;
      }
    },

    nextShow() {
      if (this.flowIndex >= 0 && this.flowIndex < 8) {
        return false;
      } else {
        return true;
      }
    },
    checkPlan() {
      this.flowIndex++;
    },
    previousPage() {
      this.flowIndex--;
    },
    async nextPage() {
      switch (this.currentPage) {
        case "pageProject":
          if (this.projectName == "") {
            this.$store.commit("scope/UNSET_VALIDATE_PROJECT_NAME", true);
          } else if (this.projectName != "" && this.appStatus) {
            this.updateLeadWithProjectName();
            this.flowIndex++;
          }
          break;
        case "pagePlans":
          break;
        case "pagePlatforms":
          if (this.platforms.length > 0) {
            await this.setUserPlatforms();
            this.flowIndex++;
          } else {
            this.$store.commit("scope/UNSET_VALIDATE_PLATFORM", true);
          }
          break;
        case "pageSuite":
          if (this.suites.length > 0) {
            await this.setUserSuites();
            this.flowIndex++;
          } else {
            this.$store.commit("scope/UNSET_VALIDATE_PLATFORM", true);
          }
          break;
        case "customFunctionalityPage":
          this.flowIndex++;
          break;
        case "pageSuiteQuestion":
          this.$store.commit("scope/VERIFY_ADDITIONAL_FEATURE", false);
          this.$store.commit("scope/VERIFIED_ADDITIONAL_FEATURE", false);
          this.setCustomFunctionality();

          break;
        case "speechToText":
          await this.$store.commit("scope/VERIFY_ADDITIONAL_FEATURE", true);
          if (this.verifiedFeature == true) {
            this.saveSpeechToText();
          }
          break;
        default:
          break;
      }
    },
    // saving custom functionality and moving to summary
    async saveSpeechToText() {
      if (this.additionalFeature.length > 25) {
        // this.flowIndex++;
        this.$vs.loading();

        setTimeout(() => {
          this.$vs.loading.close();

          this.$router.push({ name: "summaryreport" });
        }, 4000);
        const payload = {
          mobile: this.claim.userMobile,
          additionalFeature: this.additionalFeature,
        };

        const transcriptPayload = {
          target_id: "",
          requirement: this.additionalFeature,
        };
        let recommendationUrl =
          "https://api-builder-api.aiab.in/api/v1/Recommendation_v1";
        const Recommendedpages = await axios.post(recommendationUrl, {
          string: `site pages for the following user requirement in single array format only:${this.additionalFeature}`,
        });
        const Recommendedroles = await axios.post(recommendationUrl, {
          string: `User roles for the following user requirement in single strings array format only:${this.additionalFeature}`,
        });
        let arrayRecommendations = [];
        let temp = {};
        for (let i = 0; i <= Recommendedpages.data.length - 1; i++) {
          temp = {
            types: "PAGES",
            page: Recommendedpages.data[i],
          };
          arrayRecommendations.push(temp);
        }
        for (let i = 0; i <= Recommendedroles.data.length - 1; i++) {
          temp = {
            types: "ROLES",
            role: Recommendedroles.data[i],
          };
          arrayRecommendations.push(temp);
        }
        // await axios.post(
        //   `${this.url}brained/user/addScopeRequirements`,
        //   arrayRecommendations
        // );
        this.$store.commit("scope/SET_RECOMMEDATIONS", arrayRecommendations);
      }
      // await this.$store.dispatch("scope/setScopeRequirements", payload);
    },
    async setCustomFunctionality() {
      const payload = {
        mobile: this.claim.userMobile,
        custom: this.selectedSuitesQuestion[0],
      };
      await axios.post(`${this.url}brained/user/addScopeRequirements`, payload);
      if (this.selectedSuitesQuestion[0].id === 1) {
        this.$router.push({ name: "summaryreport" });
      } else if (this.selectedSuitesQuestion[0].id === 2) {
        this.flowIndex++;
      }
    },
    // set suites like electronics,portfolio
    async setUserSuites() {
      this.$vs.loading();
      let suitesData = [];
      let suitesDataID = [];

      this.suites.forEach((item) => {
        suitesDataID.push(item._id);
      });

      this.suites.forEach((item) => {
        suitesData.push(item);
      });

      const payload = {
        mobile: this.claim.userMobile,
        suites: suitesData,
      };

      await axios.post(`${this.url}brained/user/addScopeRequirements`, payload);

      //builderAPI
      await this.$store.dispatch("scope/getSuitesData", {
        suiteID: suitesDataID,
      });

      // const builderPayload = {
      //   suiteID: suitesDataID,
      // };
      // let url = "api/uibuilder/getData";
      // let pageData = await tsapi.post(url, builderPayload);

      // this.$store.commit("scope/SET_SUITE_DATA", pageData.data.data);
      this.$vs.loading.close();
    },

    async setUserPlatforms() {
      // this.$vs.loading();
      let platformData = [];
      console.log(this.platforms, "logg");
      // this.platforms.forEach((item) => {
      //   platformData.push(item.platform);
      // });
      for (let i = 0; i < this.platforms.length; i++) {
        platformData[i] = this.platforms[i].platform;
      }

      let payload = {
        mobile: this.claim.userMobile,
        platforms: platformData,
      };

      // await axios.post(`${this.url}brained/user/addScopeRequirements`, payload);
      // this.$vs.loading.close();
    },
  },
  computed: {
    ...mapState("scope", [
      "currentPage",
      "projectName",
      "platforms",
      "suites",
      "selectedSuitesQuestion",
      "verifiedFeature",
      "userDetails",
      "additionalFeature",
    ]),
  },
  mounted() {
    this.backShow();
    this.nextShow();
    this.urlFlag();
  },
};
</script>
